import { Injectable } from '@angular/core';

import { CountryInterface } from '../data';
import { MemoryCacheRepository } from './memory-cache.repository';

@Injectable()
export class CountryCacheRepository extends MemoryCacheRepository<CountryInterface[]> {}
